/* eslint-disable multiline-ternary */
import React from 'react'
import useAccountInfo from '../../../../hooks/useAccountInfo'
import Plan from './plan'
import { ListItem, Skeleton } from '@mui/material'
import BulletList from './bullet-list'
import { formatDate } from './util'

const PlanDetails = ({ 'data-test': testAttr }) => {
  const { accountInfo, accountInfoLoaded } = useAccountInfo()
  const currentPayment = accountInfo?.nextPaymentDiscount ? accountInfo?.nextPaymentDiscount : accountInfo?.nextPaymentAmount
  return (
    <BulletList loading={!accountInfoLoaded} data-test={testAttr}>
      <ListItem data-test={`${testAttr}-payment`}>
        {accountInfoLoaded ? (
          `Payment - ${currentPayment}`
        ) : (
          <Skeleton width='5rem' />
        )}
      </ListItem>
      <ListItem data-test={`${testAttr}-subscribed-since`}>
        {accountInfoLoaded ? (
          `Subscribed since ${formatDate(accountInfo.subscriptionCreatedAt)}`
        ) : (
          <Skeleton component='span' width='5rem' />
        )}
      </ListItem>
    </BulletList>
  )
}

const CurrentPlan = props => {
  return (
    <Plan
      panel={<PlanDetails data-test='retention-plan-current' />}
      {...props}
    />
  )
}

export default CurrentPlan
